import axios from 'axios'

export default {
  state: {
    email: '',
    gender: '',
    language: '',
    lastchange: '',
    name: '',
    surname: '',
    time: '',
    isLogged: false,
  },
  getters: {
    usr: state => {
      return state
    },
  },
  mutations: {
    ADD_USER(state, user) {
      state.email = user.email
      state.gender = user.gender
      state.language = user.language
      state.lastchange = user.lastchange
      state.name = user.name
      state.surname = user.surname
      state.time = user.time
      state.isLogged = true
    },
    RESET_USER(state) {
      state.email = ''
      state.gender = ''
      state.language = ''
      state.lastchange = ''
      state.name = ''
      state.surname = ''
      state.time = ''
      state.isLogged = false
    },
    lOGOUT_USER(state) {
      state.isLogged = false
    },
    SAVE_EMAIL(state, emailUser) {
      state.email = emailUser
    },
  },
  actions: {
    createUser({ commit }, eventUser) {
      commit('ADD_USER', eventUser)
    },
    saveUserEmail({ commit }, eventUser) {
      commit('SAVE_EMAIL', eventUser)
    },
    deleteUser({ commit }) {
      commit('RESET_USER')
    },
    checkLoginState({ commit, state }) {
      if (!state.name) {
        axios
          .get(process.env.VUE_APP_API_URL + 'user/data')
          .then(resp => {
            if (resp.data.code === 200) {
              commit('ADD_USER', resp.data)
            }
          })
          .catch(function () {
            commit('lOGOUT_USER')
          })
      }
    },
  },
}
